import { SignUp } from '~/pages/sign-up'
import { withUnauth } from '~/hocs/with-unauth'

export default withUnauth(SignUp)
